module.exports = __webpack_public_path__ + "static/media/busm-busd-lp.6ecf5a86.png";